/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_nav_timer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a custom countdown timer`)
};

const es_timer_nav_timer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura un temporizador de cuenta regresiva personalizado`)
};

const de_timer_nav_timer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen individuellen Countdown-Timer einstellen`)
};

const nl_timer_nav_timer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stel een aangepaste afteltimer in`)
};

const fr_timer_nav_timer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réglez un minuteur personnalisé`)
};

const it_timer_nav_timer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta un timer countdown personalizzato`)
};

const pt_br2_timer_nav_timer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defina um temporizador personalizado`)
};

const pt_timer_nav_timer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defina um temporizador de contagem decrescente personalizado`)
};

const ja_timer_nav_timer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタムカウントダウンタイマーを設定`)
};

const zh_timer_nav_timer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置自定义倒计时器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_nav_timer_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_nav_timer_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_nav_timer_desc", locale)
	if (locale === "en") return en_timer_nav_timer_desc(inputs)
	if (locale === "es") return es_timer_nav_timer_desc(inputs)
	if (locale === "de") return de_timer_nav_timer_desc(inputs)
	if (locale === "nl") return nl_timer_nav_timer_desc(inputs)
	if (locale === "fr") return fr_timer_nav_timer_desc(inputs)
	if (locale === "it") return it_timer_nav_timer_desc(inputs)
	if (locale === "pt-BR") return pt_br2_timer_nav_timer_desc(inputs)
	if (locale === "pt") return pt_timer_nav_timer_desc(inputs)
	if (locale === "ja") return ja_timer_nav_timer_desc(inputs)
	return zh_timer_nav_timer_desc(inputs)
};